import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const fetchFilesByYear = async (year, token) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/data/uploadedfiles?year=${year}`,
      {
        headers: {
          authorizationtoken: token,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching files by year:", error);
    throw error;
  }
};

export const getDownloadUrl = async (key, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/data/download`,
      { key }, // send key in the body, not as a query param
      {
        headers: {
          authorizationtoken: token,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.url; // The backend should return { url: "https://..." }
  } catch (error) {
    console.error("Error getting download URL:", error);
    throw error;
  }
};
